import { AccountCreationRequestData } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveAccount(httpClient: HttpClient) {
  return (account: AccountCreationRequestData) =>
    new Promise<void>((resolve, reject) =>
      httpClient
        .sendHttpRequest({
          endpoint: `/api/users?email=${account.email}`,
          method: HttpMethods.POST,
          data: { ...account, username: account.email },
        })
        .then(() => resolve())
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { saveAccount };
